export enum SelectionMode {
    ALL = 'ALL',
    ALL_IN_VIEW = 'ALL_IN_VIEW'
}
